/* @flow */
// "Keep screen on" switch for phones and tablets. They pause web music once the
// screen locks, so while music plays we ask the device to keep the screen awake.
import React from 'react'
import { observer, inject } from 'mobx-react'
import Switch from 'rc-switch'
import 'rc-switch/assets/index.css'
import '../AdsPanel/AdsPanel.css'
import { isSupported, keepAwake, savedSetting, saveSetting } from '../../helpers/wakeLock'
import { hasNativeAudio } from '../../helpers/nativeApp'

// Shown on touch devices (phones, tablets) and in the home-screen app
const isTouchOrApp = () => {
  try {
    return window.matchMedia('(pointer: coarse)').matches ||
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
  } catch (e) {
    return false
  }
}

const SunIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="4.2" fill="currentColor" />
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6" />
    </g>
  </svg>
)

class KeepScreenOn extends React.Component {
  state = { on: savedSetting() }

  componentDidMount () { this.sync() }
  componentDidUpdate () { this.sync() }
  componentWillUnmount () { keepAwake(false) }

  sync () {
    if (hasNativeAudio()) return
    keepAwake(this.state.on && this.props.playerStore.playing)
  }

  toggle (on) {
    saveSetting(on)
    this.setState({ on })
  }

  render () {
    // read here so mobx re-renders (and re-syncs) when play/pause changes
    const { playing } = this.props.playerStore
    // The phone app plays through a locked screen, so the switch isn't needed
    if (hasNativeAudio()) return null
    // Same switch on iPhone, iPad and Android, in the browser and the home-screen app
    if (!isSupported() || !isTouchOrApp()) return null
    const { on } = this.state
    return (
      <div className="studio__item keep-screen-on" data-playing={ playing ? 'yes' : 'no' }>
        <span className="studio__icon keep-screen-on__icon"><SunIcon /></span>
        <div className="studio__item-text">
          <span className="studio__item-title">Keep screen on</span>
          <span className="studio__item-meta">Music stops if this device locks. Keep it plugged in while it plays.</span>
        </div>
        <Switch
          checked={ on }
          onChange={ (value) => this.toggle(value) }
          aria-label="Keep the screen on while music plays"
        />
      </div>
    )
  }
}

export default inject((stores) => ({ playerStore: stores.playerStore }))(observer(KeepScreenOn))
